// extracted by mini-css-extract-plugin
export var buttons = "_8z-0";
export var buttonsActive = "_8z-h";
export var cancelConfirm = "_8z-1";
export var closeButton = "_8z-2";
export var column = "_8z-3";
export var container = "_8z-4";
export var detailHeader = "_8z-6";
export var detailTitle = "_8z-7";
export var detailsContent = "_8z-5";
export var header = "_8z-8";
export var headerWithClose = "_8z-9";
export var icon = "_8z-a";
export var infoIcon = "_8z-c";
export var informationContainer = "_8z-b";
export var sideDrawer = "_8z-d";
export var sideDrawerOpen = "_8z-e";
export var stickyFooter = "_8z-f";
export var typeOption = "_8z-g";